import * as mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'

import list from '@/store/shared/selectableList'
import search from '@/store/shared/search'

export default{
  namespaced: true,
  state () {
    return {
      expedient: undefined,
      description: undefined,
      amount: undefined
    }
  },
  mutations,
  actions,
  getters,
  modules: {
    list,
    search
  }
}
